module.exports = __webpack_public_path__ + "img/user02.ebf7f329.png";